import React, { Fragment } from 'react';

import HideIcon from '@usas/ui-web/components/icons/HideIcon';
import ShowIcon from '@usas/ui-web/components/icons/ShowIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const DetailTableRow = ({ pool }) => {
  return (
    <tr>
      <td>{pool.facilityPoolName}</td>
      <td>{pool.poolDimensions?.dimensionName}</td>
    </tr>
  )
}

const DetailTable = ({ pool }) => (
  <table className={global.DetailTable}>
    <thead>
      <tr>
        <th>Pool Number / Name</th>
        <th>Pool Dimensions</th>
      </tr>
    </thead>
    <tbody>
      {pool.facility && pool.facility.facilityPool && pool.facility.facilityPool.map((pool, i) =>
        <DetailTableRow pool={pool} key={i} />)}
    </tbody>
  </table>
);

const TableRow = ({ facility, expandedId, onClick }) => {
  return (
    <Fragment>
      <tr key={facility.facilityId}>
        <td >{facility.facility.facilityName}</td>
        <td >{facility.facility.city}</td>
        <td >{facility.facility.stateCode}</td>
        <td >{facility.facility.postalCode}</td>
        <td >{facility.facility.address1}</td>
        <td>{facility.trainingFacility === true ? 'Training' : 'Competition'}</td>
        <td>
          <button
            className={global.IconButtonMargin}
            type="button"
            onClick={(e) => onClick(e, facility.facilityId)}>
            {expandedId === facility.facilityId ? <HideIcon /> : <ShowIcon />}
          </button>
        </td>
      </tr>
      {Array.isArray(facility.facility.facilityPool) && facility.facility.facilityPool.length > 0 &&
        expandedId === facility.facilityId &&
        <tr className={global.Expanded}>
          <td colSpan="7">
            <DetailTable pool={facility} />
          </td>
        </tr>}
    </Fragment>
  );
};

const LargeClubRegistrationFacilitiesGridRead = ({ state, expandedId, onClick }) => (
  <Fragment>
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <th>Facility Name</th>
          <th>City</th>
          <th>State</th>
          <th>Zip Code</th>
          <th>Address</th>
          <th>Purpose</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {state.isArrayLoaded !== true
          ? (<tr>
            {state.isArrayLoading === true ?
              <td colSpan="7">Loading...</td> :
              <td colSpan="7">No Facilities</td>}
          </tr>)
          : Array.isArray(state.arrayData)
            && state.arrayData.length > 0
            ? state.arrayData.map((facility, i) =>
              <TableRow facility={facility} key={i} expandedId={expandedId} onClick={onClick} />)
            : (<tr>
              <td colSpan="7">No Facilities</td>
            </tr>)}
      </tbody>
    </table>
  </Fragment>
);

export default LargeClubRegistrationFacilitiesGridRead;